// libs
import * as React from "react";
import { Route, Redirect } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";

import { ROUTERS } from "../constants/routers";

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const { keycloak } = useKeycloak();

  return (
    <Route
      {...rest}
      render={(props) =>
        keycloak && keycloak.authenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: ROUTERS.LOGIN,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
